/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Business_Partner_TitleInputs */

const en_business_partner_title = /** @type {(inputs: Business_Partner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why Partner With Us`)
};

const es_business_partner_title = /** @type {(inputs: Business_Partner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por qué asociarte con nosotros`)
};

/**
* | output |
* | --- |
* | "Why Partner With Us" |
*
* @param {Business_Partner_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const business_partner_title = /** @type {((inputs?: Business_Partner_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Business_Partner_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_business_partner_title(inputs)
	return en_business_partner_title(inputs)
});